import MapChart from "../MapChart";
import Header from "./Header";

const IncomeChart = ({ scenario, client }: any) => {
  return (
    <div className="max-h-screen">
      <Header client={client} scenario={scenario} page="Income" />
      <MapChart settings={scenario} client={client} print />
    </div>
  );
};

export default IncomeChart;
